// extracted by mini-css-extract-plugin
export default {"borderContainer":"Header_borderContainer__OgLvO","container":"Header_container__sXBy4","logo":"Header_logo__VSgYN","logoAnimateContainer":"Header_logoAnimateContainer__Yt-Lo"};